function LoggedUserVO(id, login, email, firstName, lastName, roles, userType, passwordExpired, toBeVerified, clinicId,
                      officeIds, offices, doctorIds, originSystem) {

    this.id = id;
    this.login = login;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.roles = roles;
    this.userType = userType;
    this.passwordExpired = passwordExpired;
    this.toBeVerified = toBeVerified;
    this.clinicId = clinicId;
    this.officeIds = officeIds;
    this.offices = offices;
    this.doctorIds = doctorIds;
    this.originSystem = originSystem;

    var _typeContext = {
        roles: RoleVO,
        offices: OfficeVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}

LoggedUserVO.prototype.getFullName = function () {
    return this.firstName + ' ' + this.lastName;
};
